module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_0@3x.aaeb7523.png";